import monkeyPatchBaseView from "./invoca_app/monkey_patch_base_view";
import installGlobalAjaxComplete from "./invoca_app/install_global_ajax_complete";
import configureDataTables from "./invoca_app/configure_data_tables";
import setupAjax from "./invoca_app/setup_ajax";

import App from "backdraft-app/src/app";

import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";

import "shared/jquery/icon";

class InvocaApp extends App {
  constructor(plugins) {
    super(plugins);

    this.$el = null;
    this.config = null;
    this.router = null;

    monkeyPatchBaseView();
    installGlobalAjaxComplete();
    configureDataTables(this);
    setupAjax();
  }

  // create a link that will be caught by the app link handler to utilize pushState
  link(href) {
    return $("<a>")
      .attr("href", `${this.config.urlConfig.appBaseUrl}/${href}`)
      .attr("data-route", true);
  }

  installLinkHandler() {
    $('body').on("click", "[data-route]", event => {
      // pass through for new tabs, windows, downloading, etc
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
        return true;
      }
      const href = $(event.target).closest("[data-route]").attr("href");
      const fragment = href.replace(this.config.urlConfig.appBaseUrl, "");
      this.navigate(fragment);
      event.preventDefault();
    });
  }

  uninstallLinkHandler() {
    $('body').off("click", "[data-route]");
  }

  navigate(...args) {
    this.router.navigate(...args);
  }

  navigateTo(url) {
    window.location = url;
  }

  createActionTable(tableClass, initParams, options) {
    const additionalParams = {};
    if (options && options.persistSettings === true) {
      if (!this.config.tableSettings) {
        throw new Error(`${this.name}#createActionTable: Missing persisted table settings configuration!`);
      }
      additionalParams.persistedDataTableSettings = this.config.tableSettings;
      additionalParams.pageLength = this.config.tableSettings.pageLength;
    }

    const params = _.extend({}, initParams, additionalParams);
    /* eslint-disable new-cap */
    return new tableClass(params);
    /* eslint-enable new-cap */
  }

  addHeaderTooltips(toolTipConfig, tableView) {
    _.each(toolTipConfig, (toolTipOptions, columnClass) => {
      const header = tableView.$(`th.${columnClass} .DataTables_sort_interceptor`);
      if (header.find('.icon--help').length === 0) {
        const info = $("<i></i>").icon({
          icon: "help",
          className: "icon--help icon--table-header"
        });

        info.helpPopover({
          title: toolTipOptions.title,
          content: toolTipOptions.content,
          trigger: toolTipOptions.trigger || "hover",
          style: toolTipOptions.style,
          container: "body"
        });
        header.append(info);
      }
    });
  }

  createMainRouter() {
    /* eslint-disable new-cap */
    return new this.mainRouterClass({ $el: this.$el });
    /* eslint-enable new-cap */
  }

  activate($el, config) {
    const methodName = `${this.name}#activate`;

    if ($el.length === 0) {
      throw new Error(`${methodName}: $el does not exist on the page.`);
    }

    if (!_.isObject(config)) {
      throw new Error(`${methodName}: config param must be set and an object.`);
    }

    if (!config.urlConfig) {
      throw new Error(`${methodName}: config param is missing the required 'urlConfig' key.`);
    }

    if (!config.urlConfig.appBaseUrl) {
      throw new Error(`${methodName}: config.urlConfig object is missing the required 'appBaseUrl' key.`);
    }

    this.$el = $el;
    this.config = config;

    try {
      this.router = this.createMainRouter();
      this.installLinkHandler();
    } catch (ex) {
      throw new Error(`${methodName}: error instantiating router and link handler. Is 'this.mainRouterClass' defined? Original exception: ${ex.message}`);
    }

    this.onActivate();

    Backbone.history.start({
      pushState: true,
      hashChange: false,
      root: this.config.urlConfig.appBaseUrl
    });
  }

  onActivate() {
  }

  onDestroy() {
  }

  destroy() {
    Backbone.history.stop();

    this.onDestroy();

    this.uninstallLinkHandler();

    this.router.activeView && this.router.activeView.close();
    this.router = null;
    this.$el = null;
    this.config = null;
  }
}

export default InvocaApp;
